import './resources.css'

const FifthWebinarResource = () => {
    return (
        <ul className= 'additional-resources' >
            <h3> Additional Resources: </h3>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/biosecurity-resource/animal-health-disease-monitoring/")}> Animal Health & Disease Monitoring Tips (CFSPH) </li>
            <li onClick={() => window.open("https://www.cfsph.iastate.edu/biosecurity-resource/animal-movements/")}> Animal Movements Tips (CFSPH) </li>
            <li onClick={() => window.open("https://www.cfsph.iastate.edu/Assets/tip-sheet-feed-water.pdf")}> Feed and Water Biosecurity Tip Sheet (CFSPH) </li>
            {/*Nested List */}
            <li onClick={()=> window.open("https://www.cfsph.iastate.edu/Assets/tip-sheet-isolation-quarantine.pdf")}> Isolation and Quarantine Biosecurity Tip Sheet (CFSPH) </li>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/Infection_Control/Routes/English/TransmissionRoutesHandoutMarch2005.pdf")}> Disease Transmission Route Definitions (CFSPH)  </li>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/infection-control/routes/")}> Specific Diseases by Exposure Route (CFSPH) </li>

        </ul>
    )
}

export default FifthWebinarResource;